import { login, logout, getInfo } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { cryptoJSAesEncrypt } from '@/utils/encrypt'
import { resetRouter } from '@/router/paycools'
import { setLocalStorageKeyVal } from '@/utils/helper'
import { closeNotify, fetchtNotify, fetchUnreadNotificationCount } from '@/api/system/system'
import { fetchMchScopeList } from '@/api/kyc/kyc'
const MFA_OPEN = 1
const getDefaultState = () => {
  return {
    token: getToken(),
    isOpenMfa: false,
    name: '',
    mainUserName: '',
    legalMobile: '',
    legalEmail: '',
    logoImgOssUrl: '',
    nsdsStatus: false,
    avatar: '',
    userInfo: {},
    authorities: [],
    reLoginLimitTimes: 0,
    routerPath: '',
    curCountry: {},
    isAgentMerchant: false,
    timeZone: '',
    isShowModPwdModal: false,
    mch_foreign_exchange_status: false,
    isJtMerchant: false,
    isCargoMerchant: false,
    merchantCategoryArr: [],
    kycStatus: null,
    unreadNotificaionCount: 0
  }
}

const state = getDefaultState()

const mutations = {
  CHANGE_STATE: (state, { key, value }) => {
    // eslint-disable-next-line no-prototype-builtins
    if (state.hasOwnProperty(key)) {
      state[key] = value
    }
  },
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_MAIN_NAME: (state, mainUserName) => {
    state.mainUserName = mainUserName
  },
  SET_LEGAL_MOBILE: (state, legalMobile) => {
    state.legalMobile = legalMobile
  },
  SET_LEGAL_EMAIL: (state, legalEmail) => {
    state.legalEmail = legalEmail
  },
  SET_EMAIL: (state, email) => {
    state.email = email
  },
  SET_LOGO_IMG_OSS_URL: (state, logoImgOssUrl) => {
    state.logoImgOssUrl = logoImgOssUrl
  },
  SET_NSDS_BILL: (state, nsds_status) => {
    state.nsdsStatus = nsds_status
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_RELOGIN_LIMIT_TIME: (state, reLoginLimitArr) => {
    state.reLoginLimitTimes = reLoginLimitArr[0]
    state.routerPath = reLoginLimitArr[1]
  },
  SET_AUTH: (state, authorities) => {
    state.authorities = authorities
  },
  SET_CUR_COUNTRY: (state, curCountry) => {
    state.curCountry = curCountry
  },
  SET_TIME_ZONE: (state, timeZone) => {
    state.timeZone = timeZone
  },
  SET_IS_OPEN_MFA: (state, isOpen) => {
    state.isOpenMfa = isOpen
  },
  SET_MODTIFY_PWD_STATUS: (state, isShowModPwdModal) => {
    state.isShowModPwdModal = isShowModPwdModal
  },
  SET_IS_JT_MERCHANT: (state, isJtMerchant) => {
    state.isJtMerchant = isJtMerchant
  },
  SET_IS_CARGO_MERCHANT: (state, isCargoMerchant) => {
    state.isCargoMerchant = isCargoMerchant
  },
  UPDATE_MERCHANT_CATEGORY_ARR: (state, arr) => {
    state.merchantCategoryArr = arr
  },
  SET_KYC_STATUS: (state, kycStatus) => {
    state.kycStatus = kycStatus
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      login(userInfo).then(response => {
        const { data } = response
        const token = {
          value: data.token,
          expire: Date.now() + (1000 * 60 * 60)
        }
        commit('SET_TOKEN', data.token)
        setToken(JSON.stringify(token))
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      const params = {
        source: 2
      }
      getInfo(params).then(response => {
        const data = response.data || {}
        const { country_code, currency, symbol, country_cn_name, country_en_name, merchant_model, auth_codes, time_zone, mch_foreign_exchange_status } = data
        // if (!data) {
        //   return reject('Verification failed, please Login again.')
        // }

        // const { username, avatar, merchant_user, api_authorities } = data

        // const basicInfo = data.merchant_user ? data.merchant_user.basic_info : null
        // const legalMobile = basicInfo ? basicInfo.legal_person_mobile : null
        // const mainUserName = merchant_user.merchant ? merchant_user.merchant.merchant_name : ''
        // const legalEmail = basicInfo ? basicInfo.legal_person_email : null

        commit('SET_NAME', data.user_name)
        commit('SET_MAIN_NAME', data.main_user_name)
        commit('SET_AVATAR', 'avatar')
        commit('SET_LEGAL_MOBILE', data.legal_mobile)
        commit('SET_LEGAL_EMAIL', data.legal_email)
        commit('SET_IS_OPEN_MFA', data.mfa_enable === MFA_OPEN)
        commit('SET_LOGO_IMG_OSS_URL', data.logo_img_oss_url)
        commit('SET_EMAIL', data.email)
        commit('SET_USERINFO', data || {})
        commit('SET_CUR_COUNTRY', { country_code, currency, symbol, country_cn_name, country_en_name })
        commit('CHANGE_STATE', { key: 'isAgentMerchant', value: merchant_model === 2 })
        commit('CHANGE_STATE', { key: 'mch_foreign_exchange_status', value: mch_foreign_exchange_status })
        commit('SET_AUTH', auth_codes ?? [])
        commit('SET_TIME_ZONE', time_zone || 'UTC+8')
        commit('SET_IS_JT_MERCHANT', data.is_jtmerchant)
        commit('SET_IS_CARGO_MERCHANT', data.is_cargo_merchant)
        commit('SET_NSDS_BILL', data.nsds_status || false)
        commit('SET_KYC_STATUS', data.merchant_info.kyc_status || null)

        resolve(data)

        const activeTimeKey = 'ACTIVE_TIME_KEY'
        const activeLimitTime = 'ACTIVE_LIMIT_KEY'
        setLocalStorageKeyVal(activeTimeKey, (new Date()).getTime())
        setLocalStorageKeyVal(activeLimitTime, 0)
        // resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        removeToken() // must remove  token  first
        resetRouter()
        commit('RESET_STATE')
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      // 重置弹窗状态，确保重新登录后可以正常弹窗
      window._pendingPopupShown = false
      resolve()
    })
  },

  setLoginLimitTimes({ commit }) {
    return new Promise(resolve => {
      const router = window.location.hash
      if (router !== state.routerPath) { state.reLoginLimitTimes = 0 }
      commit('SET_RELOGIN_LIMIT_TIME', [state.reLoginLimitTimes + 1, router])
      resolve()
    })
  },

  resetLoginLimitTimes({ commit }) {
    return new Promise(resolve => {
      commit('SET_RELOGIN_LIMIT_TIME', 0)
      resolve()
    })
  },
  getNotifyInfo() {
    return new Promise((resolve, reject) => {
      fetchtNotify({ notify_type: 1 }).then(res => {
        resolve(res)
      }).catch(e => {
        reject(e)
      })
    })
  },
  closeNotifyInfo() {
    return new Promise((resolve, reject) => {
      closeNotify({ notify_type: 1 }).then(res => {
        resolve(res)
      }).catch(e => {
        reject(e)
      })
    })
  },
  getMerchantList({ commit }, view) {
    fetchMchScopeList().then(res => [
      commit('UPDATE_MERCHANT_CATEGORY_ARR', res.data.merchant_category)
    ])
  },
  getUnreadNotificationCount({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      fetchUnreadNotificationCount(data).then(res => {
        commit('CHANGE_STATE', { key: 'unreadNotificaionCount', value: res.data.user_unread_count })
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

